import { render, staticRenderFns } from "./NotificationsModal.vue?vue&type=template&id=c93124b6&scoped=true&"
import script from "./NotificationsModal.vue?vue&type=script&lang=ts&"
export * from "./NotificationsModal.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsModal.vue?vue&type=style&index=0&id=c93124b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93124b6",
  null
  
)

export default component.exports